import React, { useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faArrowUp, faArrowDown, faKey, faCircleNotch, faMicrophone, faFileAudio, faSpinner, faCopy, faTrash } from '@fortawesome/free-solid-svg-icons';

const Ferramentas = ({ showToast }) => {
  const [activeTab, setActiveTab] = useState('criptografia'); // 'criptografia' ou 'transferencia'
  // Estados para a aba de criptografia
  const [textoEntrada, setTextoEntrada] = useState('');
  const [textoSaida, setTextoSaida] = useState('');
  const [segredo, setSegredo] = useState('');

  // Estados para a aba de transferência rápida
  const [mensagemTransferencia, setMensagemTransferencia] = useState('');
  const [mensagensRecebidas, setMensagensRecebidas] = useState([]);
  const [codigoAcesso, setCodigoAcesso] = useState('');
  const [novoCodigo, setNovoCodigo] = useState('');

  // Estados para transcrição de áudio
  const [audioFile, setAudioFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [transcricaoTexto, setTranscricaoTexto] = useState('');
  const [transcricaoLoading, setTranscricaoLoading] = useState(false);
  // Segundos decorridos na transcrição. Whisper roda na CPU e leva ~1/3 da
  // duração do áudio; sem nenhum sinal de vida, um spinner parado por dois
  // minutos é indistinguível de travamento — foi exatamente essa a queixa.
  const [transcricaoSegundos, setTranscricaoSegundos] = useState(0);
  // Progresso REAL vindo do servidor (fim do último segmento / duração),
  // não animação: é o que distingue "está trabalhando" de "travou".
  const [transcricaoProgresso, setTranscricaoProgresso] = useState(0);
  const fileInputRef = useRef(null);
  const transcricaoTextareaRef = useRef(null);

  React.useEffect(() => {
    if (!transcricaoLoading) { setTranscricaoSegundos(0); return undefined; }
    const inicio = Date.now();
    const timer = setInterval(() => setTranscricaoSegundos(Math.floor((Date.now() - inicio) / 1000)), 1000);
    return () => clearInterval(timer);
  }, [transcricaoLoading]);

  React.useEffect(() => {
    const el = transcricaoTextareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }, [transcricaoTexto]);
  

  const getCookie = (nome) => {
    const match = document.cookie.match(new RegExp('(^| )' + nome + '=([^;]+)'));
    return match ? match[2] : null;
  };

  //--------------------------------- Funções existentes de criptografia----------------------------//

  const criptografar = async (opcao) => {
    if (!getCookie('info')) {
      await Swal.fire({ text: 'Sua sessão expirou!', icon: 'error' });
      return window.location.href = '/';
    }

    var token_autorizado = getCookie("info")

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/codificar/acao`, {
        method: 'POST',
        headers: {
            'Authority': token_autorizado,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            textoEntrada: textoEntrada, 
            chave: segredo, 
            opcao: opcao }),
      });

      const result = await response.json();
      if (result.status === 'erro') {
        await Swal.fire({ text: result.mensagem, icon: 'error' });
      } else {
        setTextoSaida(result.texto);
      }
    } catch (err) {
      console.error('Erro ao criptografar:', err);
    }
  };

  const gerarAcao = (opcao) => {
    return criptografar(opcao);
  };

  const gerarSenhaAleatoria = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJLMNOPQRSTUVWXYZ!@#$%^*+?:"';
    let senha = '';
    for (let i = 0; i < 16; i++) {
      senha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setTextoSaida(senha);
  };

  const converterMinuscula = () => setTextoSaida(textoEntrada.toLowerCase());
  const converterMaiuscula = () => setTextoSaida(textoEntrada.toUpperCase());

  const formatarJson = () => {
    try {
      const jsonString = textoEntrada
            .replace(/ObjectId\("([a-fA-F0-9]+)"\)/g, '"ObjectId(\'$1\')"')
            .replace(/ISODate\("([^"]+)"\)/g, '"ISODate(\'$1\')"')
            .replace(/NumberLong\("?([0-9]+)"?\)/g, '"NumberLong(\'$1\')"')
            .replace(/NumberInt\("?([0-9]+)"?\)/g, '"NumberInt(\'$1\')"');

      const objeto = JSON.parse(jsonString);

      const jsonFormatado = JSON.stringify(objeto, null, 4);

      const jsonFinal = jsonFormatado 
          .replace(/"ObjectId\('([a-fA-F0-9]+)'\)"/g, 'ObjectId("$1")')
          .replace(/"ISODate\('([^']+)'\)"/g, 'ISODate("$1")')
          .replace(/"NumberLong\('([0-9]+)'\)"/g, 'NumberLong($1)')
          .replace(/"NumberInt\('([0-9]+)'\)"/g, 'NumberInt($1)');
      
      setTextoSaida(jsonFinal);
    } catch (e) {
      setTextoSaida(`❌ JSON inválido: ${e.message}`);
    }
  }

  function limparObjectId(texto) {
    return texto.replace(/ObjectId\(["']?([a-f0-9]{24})["']?\)/gi, '"$1"');
  }

  function converterFormato(tipo) {
    try {
      if (tipo === 'json-csv') {

        const entradaLimpa = textoEntrada
              .replace(/ObjectId\("([a-fA-F0-9]+)"\)/g, '"ObjectId(\'$1\')"')
              .replace(/ISODate\("([^"]+)"\)/g, '"ISODate(\'$1\')"')
              .replace(/NumberLong\("?([0-9]+)"?\)/g, '"NumberLong(\'$1\')"')
              .replace(/NumberInt\("?([0-9]+)"?\)/g, '"NumberInt(\'$1\')"');

        console.log("Entrada limpa: ", entradaLimpa)

        const dados = JSON.parse(entradaLimpa);

        const array = Array.isArray(dados) ? dados : [dados];

        if (array.length === 0) {
          setTextoSaida('⚠️ JSON vazio.');
          return;
        }

        const colunas = Object.keys(array[0]);

        const csv = [
          colunas.join(', '), // cabeçalhos
          ...array.map(obj =>
            colunas.map(campo => (obj[campo] !== undefined ? obj[campo] : '')).join(', ')
          )
        ].join('\n');

        const jsonRestaurado = csv 
            .replace(/"ObjectId\('([a-fA-F0-9]+)'\)"/g, 'ObjectId($1)')
            .replace(/"ISODate\('([^']+)'\)"/g, 'ISODate("$1")')
            .replace(/"NumberLong\('([0-9]+)'\)"/g, 'NumberLong($1)')
            .replace(/"NumberInt\('([0-9]+)'\)"/g, 'NumberInt($1)');

        setTextoSaida(jsonRestaurado);

      } else if (tipo === 'csv-json') {
        const separador = textoEntrada.includes('\t') ? '\t' : ','; // detecta TAB ou vírgula
        const linhas = textoEntrada.trim().split('\n');

        if (linhas.length < 2) {
            setTextoSaida('⚠️ CSV inválido.');
            return;
        }

        const cabecalhos = linhas[0].split(separador);
        
        const json = linhas.slice(1).map(linha => {
            const valores = linha.split(separador);
            const obj = {};
            cabecalhos.forEach((campo, i) => {
                let valor = valores[i]?.trim();

                // 🔥 Detectar e ajustar tipos especiais
                if (/^ObjectId\(['"]?([a-fA-F0-9]{24})['"]?\)$/i.test(valor)) {
                    valor = `ObjectId("${valor.match(/[a-fA-F0-9]{24}/)[0]}")`;
                } else if (/^ISODate\(['"]?(.+?)['"]?\)$/i.test(valor)) {
                    const data = valor.match(/ISODate\(['"]?(.+?)['"]?\)/)[1];
                    valor = `ISODate("${data}")`;
                } else if (/^NumberLong\(['"]?(\d+)['"]?\)$/i.test(valor)) {
                    const numero = valor.match(/\d+/)[0];
                    valor = `NumberLong(${numero})`;
                } else if (/^NumberInt\(['"]?(\d+)['"]?\)$/i.test(valor)) {
                    const numero = valor.match(/\d+/)[0];
                    valor = `NumberInt(${numero})`;
                } else if (/^[a-fA-F0-9]{24}$/.test(valor)) {
                    // Se for ObjectId puro (sem função)
                    valor = `ObjectId("${valor}")`;
                } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(valor)) {
                    // ISODate pura (sem função)
                    valor = `ISODate("${valor}")`;
                } else if (/^\d+$/.test(valor)) {
                    // Números inteiros simples (NumberLong)
                    valor = `NumberLong(${valor})`;
                }
                // } else {
                //     //valor = ${valor}; // mantém como string comum
                // }

                obj[campo.trim()] = valor;
            });
            return obj;
        });

        const jsonString = JSON.stringify(json, null, 4);

        const jsonSemBarras = jsonString.replace(/\\"/g, '"');

        const jsonRestaurado = jsonSemBarras
            .replace(/"ObjectId\((.*?)\)"/g, '$1')
            .replace(/"ISODate\((.*?)\)"/g, '$1')
            .replace(/"NumberLong\((.*?)\)"/g, '$1')
            .replace(/"NumberInt\((.*?)\)"/g, '$1');

        setTextoSaida(jsonRestaurado);
        
      }
    } catch (e) {
      setTextoSaida(`❌ Erro ao converter: ${e.message}`);
    }
  }

 
 //------------------------- Funções de transcrição de áudio ----------------------------//

  const AUDIO_ACCEPT = '.mp3,.opus,.ogg,.wav,.m4a,.flac,.aac,.weba,.webm';

  const handleAudioDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) setAudioFile(file);
  };

  const handleAudioSelect = (e) => {
    const file = e.target.files[0];
    if (file) setAudioFile(file);
  };

  const transcreverAudio = async () => {
    if (!audioFile) {
      showToast('Selecione um arquivo de áudio primeiro.', 'warning');
      return;
    }

    const token_autorizado = getCookie('info');
    if (!token_autorizado) {
      await Swal.fire({ text: 'Sua sessão expirou!', icon: 'error' });
      return (window.location.href = '/');
    }

    setTranscricaoLoading(true);
    setTranscricaoTexto('');
    setTranscricaoProgresso(0);

    try {
      const formData = new FormData();
      formData.append('audio', audioFile);

      // O upload só ENFILEIRA — responde em segundos com um job_id, mesmo
      // para um áudio de 10 minutos. A transcrição em si acontece num worker
      // do servidor; aqui a gente acompanha.
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/transcricao/audio`, {
        method: 'POST',
        headers: { Authority: token_autorizado },
        body: formData,
      });

      const result = await response.json();

      if (result.status === 'erro') {
        showToast(result.mensagem, 'error');
        return;
      }

      if (result.na_frente > 0) {
        showToast(`Na fila — ${result.na_frente} áudio(s) na frente.`, 'info');
      }

      // Consulta o progresso até concluir. 2s é curto o bastante para a barra
      // parecer viva e longo o bastante para não martelar o servidor durante
      // os minutos que uma transcrição longa leva.
      const texto = await new Promise((resolve, reject) => {
        const timer = setInterval(async () => {
          try {
            const r = await fetch(`${process.env.REACT_APP_API_URL}/api/transcricao/status/${result.job_id}`, {
              headers: { Authority: token_autorizado },
            });
            const st = await r.json();

            if (st.status === 'erro') { clearInterval(timer); reject(new Error(st.mensagem)); return; }
            setTranscricaoProgresso(st.progresso || 0);
            if (st.texto_parcial) setTranscricaoTexto(st.texto_parcial);

            if (st.situacao === 'CONCLUIDA') { clearInterval(timer); resolve(st.texto || ''); }
            else if (st.situacao === 'ERRO') { clearInterval(timer); reject(new Error(st.mensagem || 'Erro ao transcrever.')); }
          } catch (e) {
            // Falha de rede pontual não cancela: o trabalho segue no servidor
            // e a próxima consulta reencontra o progresso.
            console.warn('consulta de progresso falhou, tentando de novo', e);
          }
        }, 2000);
      });

      setTranscricaoTexto(texto);
      if (!texto) showToast('A transcrição não encontrou fala neste áudio.', 'warning');
    } catch (err) {
      showToast(err.message || 'Erro ao conectar com o servidor.', 'error');
      console.error(err);
    } finally {
      setTranscricaoLoading(false);
    }
  };

  const limparTranscricao = () => {
    setAudioFile(null);
    setTranscricaoTexto('');
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

 //------------------------- Funções para a área de transferência rápida----------------------------//
//  const gerarCodigo = () => {
//   const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//   let codigo = '';
//   for (let i = 0; i < 6; i++) {
//     codigo += chars.charAt(Math.floor(Math.random() * chars.length));
//   }
//   setNovoCodigo(codigo);
// };

// const compartilharMensagem = () => {
//   if (!mensagemTransferencia.trim()) {
//     showToast('Digite uma mensagem para compartilhar', 'error');
//     return;
//   }
  
//   if (!novoCodigo) {
//     showToast('Gere um código primeiro', 'error');
//     return;
//   }
  
//   // Simulando armazenamento no localStorage (em um caso real, seria uma API)
//   localStorage.setItem(`transferencia_${novoCodigo}`, mensagemTransferencia);
//   showToast(`Mensagem compartilhada com código: ${novoCodigo}`, 'success');
//   setMensagemTransferencia('');
// };

// const buscarMensagem = () => {
//   if (!codigoAcesso.trim()) {
//     showToast('Digite um código para buscar', 'error');
//     return;
//   }
  
//   // Simulando busca no localStorage (em um caso real, seria uma API)
//   const mensagem = localStorage.getItem(`transferencia_${codigoAcesso}`);
  
//   if (mensagem) {
//     setMensagensRecebidas(prev => [...prev, { codigo: codigoAcesso, mensagem }]);
//     showToast('Mensagem encontrada!', 'success');
//   } else {
//     showToast('Nenhuma mensagem encontrada para este código', 'error');
//   }
  
//   setCodigoAcesso('');
// };

  return (
    <div className="ferramentas-container">
      {/* <div className='tabs-menu'>
        <button 
          className={activeTab === 'criptografia' ? 'active' : ''}
          onClick={() => setActiveTab('criptografia')}
        >
          <FontAwesomeIcon icon={faLock} /> Ferramentas
        </button>
        <button 
          className={activeTab === 'transferencia' ? 'active' : ''}
          onClick={() => setActiveTab('transferencia')}
        >
          <FontAwesomeIcon icon={faExchangeAlt} /> Transferência Rápida
        </button>
      </div> */}
        {activeTab === 'criptografia' && (
          <>
            <div className="form-bloco">
                <textarea
                id="entrada"
                className="form-control"
                rows="4"
                placeholder="Texto de entrada"
                value={textoEntrada}
                onChange={(e) => setTextoEntrada(e.target.value)}
               
                />
                {/* <div className="character-counter-ferramenta">
                  {textoEntrada.length}/1000 caracteres
                </div> */}
            </div>

            <div className="form-bloco">
                <input
                    className="form-control"
                    type="text"
                    placeholder="Segredo"
                    value={segredo}
                    onChange={(e) => {
                      if (e.target.value.length > 100) {
                          showToast("O segredo não pode ter mais de 100 caracteres", "warning");
                          return; // Impede a atualização se exceder
                      }
                      setSegredo(e.target.value)
                    }}
                />
            </div>
        
            <div className="acoes-container">
                <button onClick={() => gerarAcao("criptografar")}>
                    <FontAwesomeIcon icon={faLock} /> Codificar
                </button>

                <button onClick={() => gerarAcao("descriptografar")}>
                    <FontAwesomeIcon icon={faLockOpen} /> Decodificar
                </button>

            </div>

            <div className="ferramentas-secundarias">
                <button className="btn-maiuscula" onClick={converterMaiuscula}><FontAwesomeIcon icon={faArrowUp} /> Maiúscula</button>
                <button className="btn-minuscula" onClick={converterMinuscula}><FontAwesomeIcon icon={faArrowDown} /> Minúscula</button>
                <button className="btn-senha" onClick={gerarSenhaAleatoria}><FontAwesomeIcon icon={faKey} /> Gerar Senha</button>
                <button className="btn-json" onClick={formatarJson}><FontAwesomeIcon icon={faCircleNotch} /> Formatar JSON</button>
                <button className="btn-json-to-csv" onClick={() => converterFormato('json-csv')}>JSON → CSV</button>
                <button className="btn-csv-to-json" onClick={() => converterFormato('csv-json')}>CSV → JSON</button> 
            </div>

            <div className="form-bloco">
                <textarea
                    id="saida"
                    className="form-control mt-2"
                    rows="4"
                    placeholder="Texto de saída"
                    value={textoSaida}
                    readOnly
                />
            </div>

            <div className="mt-2 d-flex gap-2">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        if (textoSaida.trim() !== "") {
                            navigator.clipboard.writeText(textoSaida).then(() => {});
                            showToast('Senha copiada com sucesso!', 'success');
                        }
                    }}
                    >
                    <i className="fas fa-copy"></i> Copiar
                </button>

                <button
                    className="btn btn-secondary"
                    onClick={() => {
                        setTextoSaida("");
                    }}
                >
                    <i className="fas fa-eraser"></i> Limpar
                </button>
            </div>

            {/* ── Transcrição de Áudio ── */}
            <div className="transcricao-section">
              <div className="transcricao-header">
                <FontAwesomeIcon icon={faMicrophone} />
                <span>Transcrição de Áudio</span>
              </div>

              {/* Drag & Drop */}
              <div
                className={`audio-dropzone${isDragging ? ' dragging' : ''}${audioFile ? ' has-file' : ''}`}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={handleAudioDrop}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept={AUDIO_ACCEPT}
                  style={{ display: 'none' }}
                  onChange={handleAudioSelect}
                />
                {audioFile ? (
                  <div className="audio-file-info">
                    <FontAwesomeIcon icon={faFileAudio} className="audio-file-icon" />
                    <span className="audio-file-name">{audioFile.name}</span>
                    <span className="audio-file-size">
                      {(audioFile.size / (1024 * 1024)).toFixed(2)} MB
                    </span>
                  </div>
                ) : (
                  <div className="audio-dropzone-placeholder">
                    <FontAwesomeIcon icon={faFileAudio} className="audio-drop-icon" />
                    <p>Arraste um áudio aqui ou <span className="audio-browse-link">clique para buscar</span></p>
                    <small>MP3 · OPUS · WAV · M4A · OGG · FLAC · AAC</small>
                  </div>
                )}
              </div>

              {/* Botão transcrever */}
              <div className="transcricao-actions">
                <button
                  className="btn-transcrever"
                  onClick={transcreverAudio}
                  disabled={transcricaoLoading || !audioFile}
                >
                  {transcricaoLoading
                    ? <><FontAwesomeIcon icon={faSpinner} spin /> Transcrevendo… {transcricaoProgresso}% · {transcricaoSegundos}s</>
                    : <><FontAwesomeIcon icon={faMicrophone} /> Transcrever</>}
                </button>

                {(audioFile || transcricaoTexto) && (
                  <button className="btn-limpar-audio" onClick={limparTranscricao}>
                    <FontAwesomeIcon icon={faTrash} /> Limpar
                  </button>
                )}
              </div>

              {/* Resultado */}
              {transcricaoTexto && (
                <div className="transcricao-resultado">
                  <div className="transcricao-resultado-header">
                    <span>Resultado</span>
                    <button
                      className="btn-copiar-transcricao"
                      onClick={() => {
                        navigator.clipboard.writeText(transcricaoTexto);
                        showToast('Transcrição copiada!', 'success');
                      }}
                    >
                      <FontAwesomeIcon icon={faCopy} /> Copiar
                    </button>
                  </div>
                  <textarea
                    ref={transcricaoTextareaRef}
                    className="form-control transcricao-output"
                    value={transcricaoTexto}
                    onChange={(e) => setTranscricaoTexto(e.target.value)}
                    style={{ resize: 'none', overflow: 'hidden', minHeight: '3rem' }}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {/* {activeTab === 'transferencia' && (
          <div className="transferencia-rapida">
            <div className="form-bloco">
              <h4>Compartilhar Mensagem</h4>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Digite a mensagem que deseja compartilhar"
                value={mensagemTransferencia}
                onChange={(e) => setMensagemTransferencia(e.target.value)}
              />
              
              <div className="codigo-gerado">
                <label>Código de compartilhamento:</label>
                <div className="codigo-display">
                  {novoCodigo || 'Nenhum código gerado'}
                  <button onClick={gerarCodigo} className="btn-gerar">
                    Gerar Novo
                  </button>
                  <button 
                    onClick={compartilharMensagem}
                    className="btn btn-primary mt-2"
                  >
                    <FontAwesomeIcon icon={faClipboard} /> Compartilhar
                  </button>
                </div>
              </div>
              
              
            </div>

            <div className="form-bloco">
              <h4>Buscar Mensagem</h4>
              <div className='codigo-e-botao'>
                <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Digite o código recebido"
                      value={codigoAcesso}
                      onChange={(e) => setCodigoAcesso(e.target.value)}
                    />
                </div>
                    <button onClick={buscarMensagem} className="btn btn-success">
                      Buscar
                    </button>
              </div>
              {mensagensRecebidas.length > 0 && (
                <div className="mensagens-recebidas">
                  <h5>Mensagens Recebidas:</h5>
                  {mensagensRecebidas.map((msg, index) => (
                    <div key={index} className="mensagem-item">
                      <div className="mensagem-codigo">Código: {msg.codigo}</div>
                      <div className="mensagem-conteudo">{msg.mensagem}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )} */}
    </div>
  );
};

export default Ferramentas;
